import "@hotwired/turbo-rails"
import "./controllers"

import "@tabler/core/js/tabler"

import "trix"
import "@rails/actiontext"

// Import Active Storage Direct Upload
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import BugsnagPerformance from '@bugsnag/browser-performance'
BugsnagPerformance.start({ apiKey: 'bee7ff746f0414b36349d17fe96a0963', releaseStage: 'production'})

// Import Capacitor for native apps
import { Capacitor } from '@capacitor/core';

// Load Capacitor-specific features if we're in a native app
if (Capacitor.isNativePlatform()) {
  import('./capacitor.js').then(module => {
    // Capacitor-specific initialization is handled in the module
  });
} else {
  // Web-specific PWA features
  // service worker for PWA
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then(reg => {
          // Listen for updates
          reg.onupdatefound = () => {
            const installingWorker = reg.installing;
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  console.log('New content is available; please refresh.');
                  // Optional: force update
                  // window.location.reload();
                } else {
                  console.log('Content (service worker) is cached for offline use.');
                }
              }
            };
          };
        }).catch(error => {
          console.error('Error during service worker registration:', error);
        });
    });
  }
}

// Toggle password visibility
window.addEventListener("load", function() {
  var toggleBtn = document.getElementById("toggle-password");
  var passwordInput = document.getElementById("user_password");

  var toggleConfirmBtn = document.getElementById("toggle-confirm-password");
  var passwordConfirmInput = document.getElementById("user_password_confirm");

  var toggleInput = function(input, button) {
    if (input.type === "password") {
      input.type = "text";
      button.innerHTML = '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-eye"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" /><path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" /></svg>';
    } else {
      input.type = "password";
      button.innerHTML = '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-eye-off"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10.585 10.587a2 2 0 0 0 2.829 2.828" /><path d="M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87" /><path d="M3 3l18 18" /></svg>';
    }
  };

  if (toggleBtn && passwordInput) {
    toggleBtn.addEventListener("click", function() { 
      toggleInput(passwordInput, toggleBtn); 
    }); 
  }
  
  if (toggleConfirmBtn && passwordConfirmInput) { 
    toggleConfirmBtn.addEventListener("click", function() { 
      toggleInput(passwordConfirmInput, toggleConfirmBtn); 
    }); 
  }
});
